const COLOR_CLASS = {
  grey: "pg-badge-grey",
  yellow: "pg-badge-yellow",
  teal: "pg-badge-teal",
  red: "pg-badge-red",
  purple: "pg-badge-purple",
};

export default function StatusBadge({ color = "grey", label, testid }) {
  return (
    <span className={`pg-badge ${COLOR_CLASS[color] || COLOR_CLASS.grey}`} data-testid={testid}>
      {label}
    </span>
  );
}
